import { LockClosedIcon } from '@heroicons/react/24/outline';

export default function AccessDeniedView() {
  return (
    <div className="flex w-full flex-grow flex-col items-center justify-center gap-5 px-4 text-center md:pt-0">
      <div className="">
        <LockClosedIcon className="m-auto h-[120px] text-red-700" />
      </div>
      <div className="flex flex-col gap-2 text-lg">
        <div className="font-caudex font-bold">Access denied</div>
        <div className="font-nunito max-w-[420px] text-gray-500">
          This account has been blocked for this tenant. If you believe this is
          an error, please contact your administrator or{' '}
          <a href="mailto:support@iwarranty.co">support@iwarranty.co</a>.
        </div>
      </div>
    </div>
  );
}

